<template>
  <div class="tuolele-main-box set-combo">
    <div class="tuolele-main-search">
      <el-button type="success" @click="popImprove()">导入活动学生</el-button>
      <el-button type="info" @click="fnExportExcel()">导出Excel</el-button>
      <span style="margin-left:10px;color:#333">活动名称：{{ activeInfo.name }}</span>
    </div>
    <div class="tuolele-main-content">
      <el-table ref="student_record" :data="studentLists" border>
        <el-table-column prop="sub_name" label="学生姓名" />
        <el-table-column prop="weekend_days" label="剩余周末课时包">
          <template slot-scope="scope">
            <span :class="{'danger-font-color':scope.row.weekend_days == 0}">{{ scope.row.weekend_days }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="key_name" label="扣费类型" />
        <el-table-column label="扣费状态">
          <template slot-scope="scope">
            <span :class="{'danger-font-color':scope.row.status == '0','green-font-color': scope.row.status == '1'}">{{ scope.row.status_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="本次课耗">
          <template slot-scope="scope">
            {{ scope.row.price/100 }}元
          </template>
        </el-table-column>
        <el-table-column prop="shop_name" label="校区" />
        <el-table-column label="成本均摊">
          <template slot-scope="scope">
            {{ scope.row.cost/100 }}元
          </template>
        </el-table-column>
        <el-table-column prop="profit" label="毛利润">
          <template slot-scope="scope">
            {{ scope.row.profit/100 }}元
          </template>
        </el-table-column>
        <el-table-column label="操作" width="210">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="popExchange(scope.row.relation_id)">课包转换</el-button>
            <el-button type="danger" size="mini" @click="fnDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer pagination-footer">
        <div class="block">
          <el-pagination
            layout="prev, pager, next, slot, jumper"
            :current-page.sync="listQuery.p"
            prev-text="上一页"
            next-text="下一页"
            :total="listQuery.total"
            :page-size="listQuery.limit"
            @current-change="fnGetLists"
          />
        </div>
      </div>

    </div>
    <el-dialog title="导入学生" :visible.sync="dialogImprove" width="600px">
      <improve-active-student :key="improveKey" :activity-id="listQuery.activity_id" @successCBK="fnGetLists()" />
    </el-dialog>
    <el-dialog v-if="dialogExchange" title="转换课时包" :visible.sync="dialogExchange" width="600px">
      <active-exchange-course :key="improveKey" :relation-id="relationId" @successCBK="fnGetLists()" />
    </el-dialog>
  </div>
</template>
<script>
import improveActiveStudent from './components/ImpoveActiveStudent'
import activeExchangeCourse from './components/ActiveExchangeCourse'
import Tool from '@/assets/js/tool.js'

export default {
  name: 'StoreSetting',
  components: {
    improveActiveStudent,
    activeExchangeCourse
  },
  data() {
    return {
      dialogImprove: false,
      dialogExchange: false,
      activeInfo: {},
      improveKey: 999,
      relationId: '',
      listQuery: {
        total: 0,
        p: 1,
        limit: 20,
        activity_id: ''
      },
      studentLists: []

    }
  },
  created() {
    this.listQuery.activity_id = this.$route.query.id
  },
  mounted() {
    this.fnGetLists()
  },
  methods: {
    fnGetLists() {
      this.dialogImprove = false
      this.dialogExchange = false
      this.$http.getActivityApplyList(this.listQuery).then(res => {
        this.activeInfo = res.data.activity_info
        this.studentLists = res.data.list
      })
    },
    fnExportExcel() {
      Tool.exportExcelElTable('活动学生', this.$refs['student_record'])
    },
    popImprove(id) {
      this.improveKey++
      this.dialogImprove = true
    },
    popExchange(id) {
      this.relationId = id
      this.dialogExchange = true
    },
    fnDelete(id) {
      this.$confirm('是否删除该报名学员?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.removeJoinSub({ id }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.fnGetLists()
        })
      })
    },
    fnToDetail() {

    }

  }
}
</script>
<style lang="scss">
  .wq_flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

.wq_flex_wrap {
  flex-wrap: wrap;
}

.wq_flex_sub {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.set-combo {
  .self-table {
    margin-top: 0 !important;
  }
  .el-form-item__label {
    font-size: 16px;
    color: #333;
  }
  .el-form-item__content {
    margin: 0 20px 0 12px;
  }
  .el-button.el-button-confirm {
    width: 80px !important;
  }
}
</style>
